/**
 * This middleware only has an effect in Node.js.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function agent(opts?: any): any {
  return {}
}
